import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type {
  IOfficeConsentContentApi,
  IOfficeConsentContentApiResponse,
} from '../types/OfficeConsentContent.api';
import type { IGetOfficeConsentContentParameters } from '../types/OfficeConsentContent.parameters';

export const getOfficeConsentContent = async (
  params: IGetOfficeConsentContentParameters,
): Promise<IOfficeConsentContentApi> => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IOfficeConsentContentApiResponse>(
    `/credential-service/office/consents/${params.code}`,
    {
      headers: {
        ...headers,
        'x-office': params.officeId,
      },
    },
  );

  return response.data.data;
};
